import React from 'react';

export interface LoaderProps {
  label?: string;
  block?: boolean;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ label, block, className }) => {
  const inner = (
    <>
      <span className="rr-loader-spinner" aria-hidden="true" />
      {label && <span>{label}</span>}
    </>
  );
  if (block) {
    return (
      <div
        className={['rr-loader-block', className].filter(Boolean).join(' ')}
        role="status"
        aria-live="polite"
      >
        {inner}
      </div>
    );
  }
  return (
    <span
      className={['rr-loader', className].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
    >
      {inner}
    </span>
  );
};

export default Loader;
